import { useNavigation } from "@app/lib/navigation";
import { Modal } from "@design-system/Modal";
import { Text } from "@design-system/Typography/Text";
import { type FC } from "react";
import { useDeleteExternalQuestionnaire } from "../../data";
import { useEditOrDeleteDropdownTranslations } from "./i18n";

export const DeleteConfirmationModalContent: FC<{
    questionnaireId?: string;
}> = ({ questionnaireId }) => {
    const { t, keys } = useEditOrDeleteDropdownTranslations();

    const { navigateFromHome } = useNavigation();

    const { deleteExternalQuestionnaire, isPending: isDeletePending } =
        useDeleteExternalQuestionnaire();

    const handleDeleteApply = (id: string | undefined) => {
        return () => {
            if (!id) return;
            deleteExternalQuestionnaire(id);
            navigateFromHome("external_questionnaires");
        };
    };

    return (
        <Modal.Content className="max-w-[600px]">
            <Modal.Header withClose>
                <Modal.Title>
                    {t(keys.delete_questionnaire_modal_title)}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Text>{t(keys.delete_questionnaire_modal_description)}</Text>
            </Modal.Body>
            <Modal.Footer>
                <Modal.CancelCTA>
                    {t(keys.delete_questionnaire_modal_cancel_button_label)}
                </Modal.CancelCTA>
                <Modal.ConfirmCTA
                    onClick={handleDeleteApply(questionnaireId)}
                    variant="flatDanger"
                    loading={isDeletePending}
                >
                    {t(keys.delete_questionnaire_modal_confirm_button_label)}
                </Modal.ConfirmCTA>
            </Modal.Footer>
        </Modal.Content>
    );
};
